export const ComingSoonBanner = () => {
  return (
    <div className="bg-gradient-logo-ring text-white py-3 text-center sticky top-0 z-50 shadow-logo-ring">
      <p className="text-sm md:text-base font-medium">
        🚀 Coming Soon - Join the waitlist for early access
      </p>
    </div>
  );
};
